export default __webpack_public_path__ + "static/media/ChevronUp.f1780295.svg";